<script>
    import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
    import {
      faChevronLeft,
      faChevronRight,
      faChevronsLeft,
      faChevronsRight
    } from '@fortawesome/pro-light-svg-icons';
  
    export let currentPage = 1;
    export let totalPages = 1;
    export let onPageChange = (page) => {};

    function goToPage(page) {
      if (page >= 1 && page <= totalPages) {
        onPageChange(page);
      }
    }

    function handleInputChange(event) {
      const value = parseInt(event.target.value, 10);
      if (!isNaN(value)) {
        goToPage(value);
      }
    }
</script>

<div class="flex items-center space-x-2">
  <button
    class="p-1.5 rounded hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 disabled:opacity-50 disabled:cursor-not-allowed"
    on:click={() => goToPage(1)}
    disabled={currentPage === 1}
  >
    <FontAwesomeIcon icon={faChevronsLeft} />
  </button>
  
  <button
    class="p-1.5 rounded hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 disabled:opacity-50 disabled:cursor-not-allowed"
    on:click={() => goToPage(currentPage - 1)}
    disabled={currentPage === 1}
  >
    <FontAwesomeIcon icon={faChevronLeft} />
  </button>
  
  <div class="flex items-center">
    <input
      type="text"
      class="w-12 p-1 h-6 rounded border border-slate-300 dark:border-slate-600 text-center text-sm bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300"
      min="1"
      max={totalPages}
      value={currentPage}
      on:change={handleInputChange}
    />
    <span class="text-sm text-slate-500 dark:text-slate-400 mx-1">of {totalPages}</span>
  </div>
  
  <button
    class="p-1.5 rounded hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 disabled:opacity-50 disabled:cursor-not-allowed"
    on:click={() => goToPage(currentPage + 1)}
    disabled={currentPage === totalPages}
  >
    <FontAwesomeIcon icon={faChevronRight} />
  </button>
  
  <button
    class="p-1.5 rounded hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 disabled:opacity-50 disabled:cursor-not-allowed"
    on:click={() => goToPage(totalPages)}
    disabled={currentPage === totalPages}
  >
    <FontAwesomeIcon icon={faChevronsRight} />
  </button>
</div>

<style>
  /* Pagination styles */
</style>